module.exports = __webpack_public_path__ + "res/img/birth.08290dc4.png";